import {
    collection,
    query,
    getDocs,
    setDoc,
    doc,
    QueryDocumentSnapshot,
    DocumentData,
    where,
    deleteDoc,
} from 'firebase/firestore';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { AdditionalExercise } from '../types';

const mapSnapshotToAdditionalExercise = (doc: QueryDocumentSnapshot<DocumentData>) => {
    return {
        ...doc.data(),
        id: doc.id,
    } as AdditionalExercise;
};

const mapAdditionalExerciseToSnapshot = (additionalExercise: AdditionalExercise) => {
    return {
        ...additionalExercise,
        backpack: additionalExercise.backpack ?? false,
        image: additionalExercise.image ?? '',
    };
};

export const getAdditionalExercisesFirebase = async (ids: string[]) => {
    const q = query(collection(db, DbCollections.AdditionalExercises), where('id', 'in', ids));
    const querySnapshot = await getDocs(q);
    const additionalExercises = [] as AdditionalExercise[];
    querySnapshot.forEach(async (doc) => {
        additionalExercises.push(mapSnapshotToAdditionalExercise(doc));
    });

    return additionalExercises.sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id));
};

export const saveAdditionalExerciseFirebase = async (additionalExercise: AdditionalExercise) => {
    await setDoc(
        doc(db, DbCollections.AdditionalExercises, additionalExercise.id),
        mapAdditionalExerciseToSnapshot(additionalExercise),
    );
    return additionalExercise;
};

export const deleteAdditionalExerciseFirebase = async (id: string) => {
    await deleteDoc(doc(db, DbCollections.AdditionalExercises, id));
    return id;
};
